import React, {useState} from 'react';

import {AppButton} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import appContent from '@/services/content/appContent';

import DeviceSettingLayout from '../../components/DeviceSettingLayout/DeviceSettingLayout';
import UsbConnectionRequiredPopup from '../../components/UsbConnectionRequiredPopup/UsbConnectionRequiredPopup';

const FirmwareNotice = () => {
    const {title, description, icon, noticeIcon, instructions, continueButton} = appContent.getUpdateFirmwareNotice();
    const [isUsbConnectionRequiredPopupVisible, setIsUsbConnectionRequiredPopupVisible] = useState(false);

    const handleOnContinueClick = () => {
        // Logic to start the firmware upgrade process
        console.log('Firmware upgrade continue pressed');

        // TEMP: showing the USB connection required popup manually for debugging.
        // In the future, this should be triggered by proper flow logic.
        setIsUsbConnectionRequiredPopupVisible(true);
    };

    return (
        <DeviceSettingLayout
            footer={
                <AppButton className='w-full' primary light onClick={handleOnContinueClick} alt={continueButton.alt}>
                    {continueButton.text}
                </AppButton>
            }
        >
            <DeviceSettingLayout.ContentHeader icon={icon} title={title} description={description} />
            <DeviceSettingLayout.ControlsContainer className='flex flex-col items-center gap-6'>
                <p className='text-center'>{instructions.step1}</p>
                <div className='flex w-full flex-row items-center rounded-xl bg-primary-dark-5 p-3'>
                    <RemoteIconV2 icon={noticeIcon} className='mr-3 h-12 w-12 shrink-0' />
                    <span className='text-start'>{instructions.tip}</span>
                </div>
                <p className='text-center'>{instructions.step2}</p>
            </DeviceSettingLayout.ControlsContainer>

            {isUsbConnectionRequiredPopupVisible && (
                <UsbConnectionRequiredPopup
                    onClose={() => setIsUsbConnectionRequiredPopupVisible(false)}
                    onButtonClick={() => setIsUsbConnectionRequiredPopupVisible(false)}
                />
            )}
        </DeviceSettingLayout>
    );
};

export default FirmwareNotice;
